import AltaLoginLogo from "./AltaLoginLogo";
import styles from "../pages/Login.module.css";

export default function AuthCheckLoading() {
  return (
    <div className={styles.page}>
      <div className={styles.authCheck} role="status" aria-live="polite" aria-busy="true">
        <div className={styles.splashLogo}>
          <AltaLoginLogo />
        </div>
        <span className={styles.authSpinner} aria-hidden="true" />
        <p className={styles.authCheckText}>Anmeldung wird geprüft …</p>
      </div>
    </div>
  );
}